(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animations"] && !Shopify.designMode) return;
  try {
    // Shared, ref-counted scroll lock so multiple overlays (menu drawer, cart drawer) can't
  // clobber each other's body-overflow reset — closing one no longer unlocks the page while
  // another is still open.
  if (!window.MetryScrollLock) {
    window.MetryScrollLock = (function () {
      var count = 0;
      return {
        lock: function () { count++; document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; },
        unlock: function () { count = Math.max(0, count - 1); if (count === 0) { document.documentElement.style.overflow = ''; document.body.style.overflow = ''; } }
      };
    })();
  }

  (function () {
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('reveal-in');
      });
    }

    function initReveal() {
      var els = document.querySelectorAll('[data-reveal]');
      if (reduce || !('IntersectionObserver' in window)) {
        revealAll();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initImageFade() {
      document.querySelectorAll('img.lazy-fade').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
        }
      });
    }

    function start() { initReveal(); initImageFade(); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-code')) {
    customElements.define('gift-code', class extends HTMLElement {
      connectedCallback() {
        const b = this.querySelector('[data-code]');
        if (b) b.addEventListener('click', () => {
          if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.code);
          b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-product-card"] && !Shopify.designMode) return;
  try {
    class MtProductCard extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
    onClick = async (event) => {
      const button = event.target.closest('[data-mt-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: button.dataset.variantId, quantity: 1 })
        });
        if (!response.ok) throw new Error('Unable to add product');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
      } finally {
        button.disabled = false;
      }
    };
  }
  if (!customElements.get('mt-product-card')) customElements.define('mt-product-card', MtProductCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recently-viewed-tracker"] && !Shopify.designMode) return;
  try {
    class RecentlyViewedTracker extends HTMLElement {
    connectedCallback() {
      const productId = this.dataset.productId;
      if (!productId) return;
      try {
        const storageKey = 'mt-recently-viewed';
        const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const productIds = Array.isArray(stored) ? stored.map(String).filter((id) => /^\d+$/.test(id)) : [];
        const updatedIds = [String(productId), ...productIds.filter((id) => id !== String(productId))].slice(0, 12);
        localStorage.setItem(storageKey, JSON.stringify(updatedIds));
      } catch (error) {
        return;
      }
    }
  }
  if (!customElements.get('recently-viewed-tracker')) customElements.define('recently-viewed-tracker', RecentlyViewedTracker);
  } catch(e) { console.error(e); }
})();

})();
